/**
 * Jambuveda FAQ accordion — simple, one-at-a-time or independent toggle.
 */
(function () {
  const items = document.querySelectorAll('.jv-faq__item');
  items.forEach((item) => {
    const btn = item.querySelector('.jv-faq__q');
    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
})();
